import React from "react"
import MfaVerifyContainer from "../../containers/MfaVerifyContainer/MfaVerifyContainer"

const MfaVerifyPage = () => {
  return <MfaVerifyContainer />
}

export default MfaVerifyPage
